import { render, staticRenderFns } from "./TopScorerInTeam.vue?vue&type=template&id=0af6e8dd&scoped=true&"
import script from "./TopScorerInTeam.vue?vue&type=script&lang=js&"
export * from "./TopScorerInTeam.vue?vue&type=script&lang=js&"
import style0 from "./TopScorerInTeam.vue?vue&type=style&index=0&id=0af6e8dd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af6e8dd",
  null
  
)

export default component.exports